/**
 * Help coaching for the whole organization (`organizations/{orgId}/settings/coaching`).
 * ON unless an admin turned it off: an absent doc, or one without `enabled`, means on.
 * Off stops tips and weekly recaps for every member (the backend reads the same rule).
 */
export function coachingEnabledFrom(data: { enabled?: unknown } | undefined | null): boolean {
  return data?.enabled !== false;
}
